import { useCallback } from 'react';

const LIGHTBOX_WIDTH = 300;
const MARGIN = 10;
const TOTAL_SPACE_NEEDED = LIGHTBOX_WIDTH + MARGIN;

export const usePositioning = () => {
  const generatePositionStyle = useCallback(({ containerRef, anchorRef }) => {
    const containerEl = containerRef?.current;
    if (!containerEl) return {};

    const containerRect = containerEl.getBoundingClientRect();
    const anchorEl = anchorRef?.current || containerEl;
    const anchorRect = anchorEl.getBoundingClientRect();
    const windowWidth = window.innerWidth;

    const spaceOnRight = windowWidth - anchorRect.right;
    const spaceOnLeft = anchorRect.left;

    const hasEnoughSpaceOnRight = spaceOnRight >= TOTAL_SPACE_NEEDED;
    const hasEnoughSpaceOnLeft = spaceOnLeft >= TOTAL_SPACE_NEEDED;

    // If an anchor is provided (e.g., sub-theme lightbox), position relative to it
    if (anchorRef?.current) {
      if (hasEnoughSpaceOnRight) {
        const left = (anchorRect.left - containerRect.left) + anchorRect.width + MARGIN;
        return { left, right: 'unset' };
      }
      if (hasEnoughSpaceOnLeft) {
        const right = (containerRect.right - anchorRect.left) + MARGIN;
        return { right, left: 'unset' };
      }
      const left = (anchorRect.left - containerRect.left) + anchorRect.width + MARGIN;
      return { left, right: 'unset' };
    }

    // Default: position relative to the container itself (for the first sub-lightbox)
    if (hasEnoughSpaceOnRight) {
      return { left: containerRect.width + MARGIN, right: 'unset' };
    }
    if (hasEnoughSpaceOnLeft) {
      return { right: LIGHTBOX_WIDTH + MARGIN, left: 'unset' };
    }
    return { left: containerRect.width + MARGIN, right: 'unset' };
  }, []);

  const generateLeftSideStyle = useCallback(({ containerRef }) => {
    const containerEl = containerRef?.current;
    if (!containerEl) return {};

    const containerRect = containerEl.getBoundingClientRect();
    const spaceOnLeft = containerRect.left;

    if (spaceOnLeft >= TOTAL_SPACE_NEEDED) {
      return { right: containerRect.width + MARGIN, left: 'unset' };
    }
    // Fallback: open on the right if not enough space on the left
    return { left: containerRect.width + MARGIN, right: 'unset' };
  }, []);

  return {
    generatePositionStyle,
    generateLeftSideStyle,
  };
};
